import { ApiResponse } from './for-api';
import { Contact } from './program';

export interface ClientDetails {
  state: string;
  message: string;
  accountNumber: string;
  subCodeStatus: string;
  experianContactName: string;
  experianContactEmail: string;
  clientName: string;
  listConvertErrorPctMax: string;
  doNotProcessDupsFlag: string;
  noPinPctMax: string;
}

export interface ClientContact {
  recordType: string;
  addressType: string;
  entityName: string;
  thirdPartyId: number;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
  contactName: string;
  contactEmail: string;
  stsFolderId: string;
}

export interface ClientAttributes {
  details: ClientDetails;
  contacts: ClientContact[];
}

export type ClientAttributesApiResponse = ApiResponse<ClientAttributes>;

export const asContact = (clientContact: ClientContact): Contact => {
  return {
    name: clientContact.contactName,
    clientName: clientContact.entityName,
    email: clientContact.contactEmail,
    address: clientContact.address1,
    city: clientContact.city,
    state: clientContact.state,
    zipCode: clientContact.zipCode,
    phoneNumber: '',
  };
};
